<!--  -->
<template>
  <div class="nav">
    <div class="btn-box">
      <div class="btn">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title"],
  components: {},
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.nav {
  width: 100%;
  height: 50px;
  background-color: #f4f9ff;
  .btn-box {
    width: 1200px;
    margin: 0 auto;
    .btn {
      width: 150px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-color: #5197d5;
      color: #fff;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Nav/Nav.vue